"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityObserver = exports.IdentityEventTypes = void 0;
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var IdentityEventTypes;
(function (IdentityEventTypes) {
    IdentityEventTypes["FETCHING"] = "FETCHING";
    IdentityEventTypes["FETCHED"] = "FETCHED";
    IdentityEventTypes["UPDATED"] = "UPDATED";
    IdentityEventTypes["UNAUTHORIZED"] = "UNAUTHORIZED";
    IdentityEventTypes["ERROR"] = "ERROR";
})(IdentityEventTypes = exports.IdentityEventTypes || (exports.IdentityEventTypes = {}));
var IdentityObserver = /** @class */ (function () {
    function IdentityObserver(options) {
        this._subscribers = new Set();
        this._watcherUnsubscribeFunctions = [];
        this._userLastActiveAt = Date.now();
        this._options = options;
        if (!this._options.lsApiBaseUrl) {
            throw new Error('[IdentityObserver] Missing option "lsApiBaseUrl"');
        }
        this._options.requestTimeoutMs = Math.max(5000, this._options.requestTimeoutMs || 0);
    }
    /**
     * Subscribe to changes to the current user's identity
     */
    IdentityObserver.prototype.subscribe = function (callback, _a) {
        var _this = this;
        var _b = _a === void 0 ? { fetchOnInit: false } : _a, fetchOnInit = _b.fetchOnInit;
        if (!this._watcherUnsubscribeFunctions.length) {
            this._initWatchers();
        }
        if (!this._subscribers.has(callback)) {
            this._subscribers.add(callback);
        }
        if (fetchOnInit) {
            this._ensureValidSession();
        }
        return function () {
            _this._subscribers.delete(callback);
            // If this is the last subscription to be removed, clean up all the intervals and watcher functions
            if (_this._subscribers.size === 0) {
                _this.cleanupWatchers();
            }
        };
    };
    /**
     * Tells if the user should be auto-logged out. It can either happen when the user
     * is still logged-in (for example when there is an identity change) or when LSID
     * returns unauthorized (`401`).
     */
    IdentityObserver.prototype.isAutoLogoutEnabled = function () {
        var _a, _b, _c, _d;
        return (((_c = (_b = (_a = this._identityResponse) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.features) === null || _c === void 0 ? void 0 : _c.includes('lsid_auto_logout')) ||
            ((_d = this._identityResponse) === null || _d === void 0 ? void 0 : _d.headers.get('X-Ls-Auto-Logout')) === '1');
    };
    /**
     * Verifies the `sub` value of the identity payload to determine if its a session token.
     */
    IdentityObserver.prototype.isSession = function () {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this._identityResponse) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.sub) === null || _c === void 0 ? void 0 : _c.startsWith('Session:')) || false;
    };
    /**
     * Reach out to LSID service and return the current user's identity.
     *
     * If the response is not returned within 5 seconds, we reject with an error.
     *
     * This function is manually throttled so that we only have a single request pending at a time
     * So, if a request is already in flight, we will return the result of that instead of having multiple concurrent requests.
     *
     */
    IdentityObserver.prototype.fetchIdentity = function () {
        var _this = this;
        if (this._fetchInProgress) {
            return this._fetchInProgress;
        }
        var timeoutMs = this._options.requestTimeoutMs || 5000;
        var timeoutError = "[IdentityObserver] Timed out fetching identity after ".concat(timeoutMs, "ms");
        var controller = null;
        if (typeof AbortController !== 'undefined') {
            controller = new AbortController();
        }
        this._fetchInProgress = Promise.race([
            fetch("".concat(this._options.lsApiBaseUrl, "/auth/identity"), {
                credentials: 'include',
                signal: controller === null || controller === void 0 ? void 0 : controller.signal,
            }).catch(function (error) {
                if (error.name === 'AbortError') {
                    throw new Error(timeoutError);
                }
                else {
                    throw error;
                }
            }),
            // If our request takes too long, throw an error so we don't hang for a long time
            new Promise(function (_resolve, reject) {
                setTimeout(function () {
                    // Prefer canceling the request using `AbortController` over a naive timeout + `Promise.reject`
                    // The `Promise.reject` alternative does not close the underlying TCP connection,
                    // so it's possible for open connections to build up when using this method
                    if (controller) {
                        controller.abort();
                    }
                    else {
                        reject(new Error(timeoutError));
                    }
                }, timeoutMs);
            }),
        ])
            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var ok, status, headers, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ok = response.ok, status = response.status, headers = response.headers;
                        data = null;
                        if (!ok) return [3 /*break*/, 2];
                        return [4 /*yield*/, response.json()];
                    case 1:
                        data = _a.sent();
                        _a.label = 2;
                    case 2:
                        this._identityResponse = {
                            data: data,
                            ok: ok,
                            status: status,
                            headers: headers,
                        };
                        this._fetchInProgress = undefined;
                        return [2 /*return*/, this._identityResponse];
                }
            });
        }); })
            .catch(function (error) {
            _this._fetchInProgress = undefined;
            throw error;
        });
        return this._fetchInProgress;
    };
    /**
     * Remove all subscribers and clean up the watcher functions
     * This is mostly useful for cleanup during testing
     */
    IdentityObserver.prototype.cleanupWatchers = function () {
        this._watcherUnsubscribeFunctions.forEach(function (unsubscribe) {
            unsubscribe();
        });
        this._watcherUnsubscribeFunctions = [];
    };
    // Private
    IdentityObserver.prototype._publish = function (event) {
        this._subscribers.forEach(function (subscriber) {
            subscriber(event);
        });
    };
    IdentityObserver.prototype._initWatchers = function () {
        this._watcherUnsubscribeFunctions.push(this._watchForUserActivity(), this._watchIdentityOnTimer(), this._watchIdentityOnWindowFocus());
    };
    /**
     * Reach out to the LSID service to determine whether our current session is valid
     * This call is throttled to avoid multiple calls within a short time period
     * This call is blocked if the user is inactive
     */
    // eslint-disable-next-line consistent-return
    IdentityObserver.prototype._ensureValidSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oldIdentityResponse, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._userIsActive()) {
                            return [2 /*return*/, false];
                        }
                        this._publish({
                            type: IdentityEventTypes.FETCHING,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        oldIdentityResponse = this._identityResponse;
                        return [4 /*yield*/, this.fetchIdentity()];
                    case 2:
                        response = _a.sent();
                        this._publish({
                            type: IdentityEventTypes.FETCHED,
                            response: response,
                        });
                        if (!response.ok) {
                            if (response.status === 401) {
                                this._publish({
                                    type: IdentityEventTypes.UNAUTHORIZED,
                                });
                            }
                            else {
                                throw new Error('[IdentityObserver] An error occurred trying to verify current session');
                            }
                        }
                        else if (!(0, isEqual_1.default)(oldIdentityResponse, response)) {
                            this._identityResponse = response;
                            this._publish({
                                type: IdentityEventTypes.UPDATED,
                                identity: response.data,
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this._publish({
                            type: IdentityEventTypes.ERROR,
                            error: error_1,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Our LSID session may change without a corresponding network request to inform us
     * To detect these sort of changes, we check periodically whether our session is still valid
     */
    IdentityObserver.prototype._watchIdentityOnTimer = function () {
        var _this = this;
        var interval = setInterval(function () {
            _this._ensureValidSession();
        }, 30 * 1000); // 30 seconds
        return function () {
            clearInterval(interval);
        };
    };
    /**
     * Our LSID session may change after a period of inactivity
     * without a corresponding network request to inform us
     *
     * When refocusing the window or changing the tab visibility
     * we recheck our session to make sure it's still valid
     */
    IdentityObserver.prototype._watchIdentityOnWindowFocus = function () {
        var _this = this;
        var onFocus = function () {
            _this._ensureValidSession();
        };
        window.addEventListener('focus', onFocus);
        var onVisibilityChange = function () {
            if (document.visibilityState === 'visible') {
                _this._ensureValidSession();
            }
        };
        window.addEventListener('visibilitychange', onVisibilityChange);
        return function () {
            window.removeEventListener('focus', onFocus);
            window.removeEventListener('visibilitychange', onVisibilityChange);
        };
    };
    /**
     * Subscribe to events that constitute user activity
     */
    IdentityObserver.prototype._watchForUserActivity = function () {
        var _this = this;
        var onActivity = function () {
            _this._onUserActivity();
        };
        window.addEventListener('focus', onActivity);
        window.addEventListener('click', onActivity);
        return function () {
            window.removeEventListener('focus', onActivity);
            window.removeEventListener('click', onActivity);
        };
    };
    IdentityObserver.prototype._userIsActive = function () {
        var msSinceActive = Date.now() - this._userLastActiveAt;
        var secondsSinceActive = msSinceActive / 1000;
        var minutesSinceActive = secondsSinceActive / 60;
        return minutesSinceActive < 1;
    };
    IdentityObserver.prototype._onUserActivity = function () {
        this._userLastActiveAt = Date.now();
    };
    return IdentityObserver;
}());
exports.IdentityObserver = IdentityObserver;
